<template>
  <div>
    <div class="card-body">
      <div class="tab-content">
        <div class="tab-pane active" id="activity">
          <div class="row">
            <div class="col-md-12">
              <h5 class="h4-t">Employee Next of Kin</h5>
              <hr />
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm">
                  <thead class="bg-info">
                    <tr>
                      <th>Relation</th>
                      <th>Name</th>
                      <th>CNIC</th>
                      <th>Percentage</th>
                      <th>PhoneNo.</th>
                      <th style="width: 10px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in Kins">
                      <td>{{item.Relation}}</td>
                      <td>{{item.Name}}</td>
                      <td>{{item.CNIC}}</td>
                      <td>{{item.Percentage}}%</td>
                      <td>{{item.PhoneNo}}</td>
                      <td style="white-space: nowrap">
                        <button class="btn btn-sm btn-info" v-on:click="showKinModal(item, ind)"><i class="fas fa-edit"></i></button>
                        <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteKin" v-on:click="KinIndex = ind;"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="totalPercentage < 100">
                    <tr>
                      <td colspan="7">
                        <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showKinModal()">Add New</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.tab-content -->
    </div>
    <div class="card-footer">
      <a class="btn btn-primary" href="../Employees/List">Back to List</a>
      <div class="float-right">
        <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
        <!--<input type="submit" value="Save Profile" class="btn btn-success  " />-->
      </div>
    </div>
    <div class="modal fade" id="modalKin">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Next Of Kin</h4>
          </div>
          <form id="contact" v-on:submit="saveKin">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Relation</label>
                    <select class="form-control" id="ddlReligion" v-model="Kin.RelationID">
                      <option value="0" selected="selected">--Select--</option>
                      <option v-bind:value="item.Name" v-for="(item,index) in relations" :value="item.RelationID">{{item.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Name</label>
                    <input class="form-control form-control-sm" v-model="Kin.Name" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Percentage</label>
                    <input type="text" class="form-control form-control-sm" v-mask="'###'" v-model="Kin.Percentage" v-bind:max="maxPer" min="1" required/>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>CNIC</label>
                    <input type="text" v-mask="'#############'" class="form-control form-control-sm" v-model="Kin.CNIC" required/>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Phone Number</label>
                    <input type="text" v-mask="'############'" class="form-control form-control-sm" v-model="Kin.PhoneNo" required/>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modalDeleteKin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <h3>Are you sure you want to delete this record ?</h3>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" v-on:click="deleteContact()" class="btn btn-danger">Delete</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

  </div>
</template>

<script>

  $(document).ready(function () {
    $('[data-mask]').inputmask()
  });

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number, 
    },
    data() {
      return {
        Kins: [], 
        relations: [],
        Kin: {
          EmployeeNextOfKinID: "",
          EmployeeID: '',
          PhoneNo: '',
          RelationID: 0,
          CNIC: '',
          Percentage: '%',
          Name:''
        },
        KinIndex: -1,
        maxPer: 100,
        totalPercentage:0,
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/EmployeesApi/pageLoadNextOfKin?id=' + vm.employeeId)
          .then(function (res) {
            endReq();

            vm.relations = res.data.relations;  

            if (res.data.Kins) {
              vm.totalPercentage = res.data.total;
              vm.Kins = res.data.Kins;
            }

          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showKinModal(data, index) {
        //$('#myModal').modal({ backdrop: 'static', keyboard: false })  
          if (data) {
            this.Kin = Object.assign({}, data);
            this.KinIndex = index
          } 
     
        else {
          this.Kin = {
            EmployeeNextOfKinID: "",
            EmployeeID: '',
            PhoneNo: '',
            RelationID: 0,
            CNIC: '',
            Percentage: '',
            Name: ''
          };
          this.KinIndex = -1;
        }


        $('#modalKin').modal('show');
      },

      saveKin(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/saveKin?id=' + vm.employeeId, {
          Kin: vm.Kin
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.pageLoad();

              vm.Kin = {
                EmployeeNextOfKinID: "",
                EmployeeID: '',
                PhoneNo: '',
                RelationID: 0,
                CNIC: '',
                Percentage: '',
                Name: ''
              };
            }
            else
              toastr.error(res.data.msg);

          }).catch(function (err) {
            endReq();
            var res = err.response;
            if (res.status == 401) {
              toastr.error(res.data);
            }
            else {
              for (const [key, value] of Object.entries(res.data.errors)) {
                toastr.error(`${value}`);
              }
            }
          })
      },

      deleteContact() {
        var vm = this;
        startReq();
        axios.get('/api/EmployeesApi/deleteKin?id=' + vm.Kins[vm.KinIndex].EmployeeNextOfKinID)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Deleted Successfully", "Done!");
              vm.Kins.splice(vm.KinIndex, 1);
              vm.KinIndex = -1;
              $('#modalDeleteKin').modal('hide');
              vm.pageLoad();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      clear() {
        location.reload();
      }

    }
  })
</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>



// WEBPACK FOOTER //
// src/components/hr/employeeNextOfKin.vue